module.exports = __webpack_public_path__ + "static/media/27OCHA19.98a9ea9a.jpg";